export function isAirportArea(code, areas = []) {
  if (!code || code === 'other') return false;
  const area = areas.find(item => item.code === code);
  const text = [code, area?.name_en, area?.name_ja, area?.name_zh].filter(Boolean).join(' ');
  return /airport|空港|机场|機場/i.test(text) && !/hotel|ホテル|酒店/i.test(text);
}

export function appendAirportFlightNotes(notes, pickupFlight, endFlight) {
  return [notes,
    pickupFlight ? `乗車空港の便名: ${pickupFlight}` : '',
    endFlight ? `降車空港の便名: ${endFlight}` : '',
  ].filter(Boolean).join('\n');
}
